import { Icon } from 'components';

/**
 * The one refresh control for every level of the Insights drill-down — page header, module
 * items list, and the item drawer.
 *
 * Insights has no rollups and no cron: every panel is a live aggregation over the raw event
 * collection (see api/admin/insights/*), so what is on screen is only ever as fresh as the last
 * fetch, and the numbers move while an admin is looking at them. Filters already refetch on
 * change; this is for the case where nothing about the query changed and the admin just wants
 * the current figure.
 *
 * Shared rather than three hand-rolled buttons so the affordance reads the same everywhere and
 * the disabled-while-loading rule cannot be forgotten in one place — without it a double click
 * fires two aggregations, and the slower one wins and can land stale over the newer response.
 */
const RefreshButton = ({ onClick, refreshing, disabled, label, title = 'Refresh' }) => {
  const isDisabled = disabled || refreshing;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      title={title}
      aria-label={title}
      className={`h-8 shrink-0 inline-flex items-center gap-1.5 rounded-lg border border-[#CBD5E1] bg-white text-[12px] font-medium text-[#334155] transition-colors hover:border-[#94A3B8] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-[#CBD5E1] ${
        label ? 'px-3' : 'w-8 justify-center'
      }`}
    >
      {/* `animate-spin` sits on a wrapper, not the Icon: `Icon` renders a styled div and spreads
          its props onto it, so a className passed through would be overwritten by the styled
          component's own generated class. */}
      <span className={`flex items-center ${refreshing ? 'animate-spin' : ''}`}>
        <Icon type="refresh" dimensions={14} col="#64748B" />
      </span>
      {label && <span>{refreshing ? 'Refreshing…' : label}</span>}
    </button>
  );
};

export default RefreshButton;
